import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title", "pathRest"];
var IconTimeSolid = function IconTimeSolid(_ref) {
  var title = _ref.title,
    pathRest = _ref.pathRest,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-time-solid"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", _extends({
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m3.2 13.2a1 1 0 0 1-1.4 0l-2.5-2.5a1 1 0 0 1-.3-.7V7a1 1 0 0 1 2 0v4.59l2.2 2.2a1 1 0 0 1 0 1.42"
  }, pathRest)));
};
IconTimeSolid.displayName = 'InlineIcon(IconTimeSolid)';
IconTimeSolid.propTypes = {
  title: PropTypes__default.string,
  pathRest: PropTypes__default.object
};

export { IconTimeSolid };
